import { ethereum } from '@0xtorch/core'
import { base } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createBaseChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createBaseChainCustom({
    client: createClient({
      chain: base,
      httpRpcs: baseHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'BaseScan',
      baseUrl: 'https://basescan.org',
      chainId: 8453,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateBaseChainParameters = {
  client: Client
  explorer: Explorer
}

export const createBaseChainCustom = ({
  client,
  explorer,
}: CreateBaseChainParameters): Chain => ({
  id: 8453,
  network: 'base',
  name: 'Base',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'base',
  defillamaId: 'base',
})

export const baseHttpRpcs: HttpRpc[] = [
  {
    url: 'https://mainnet.base.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  {
    url: 'https://developer-access-mainnet.base.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://base-mainnet.diamondswap.org/rpc',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://base.public.blockpi.network/v1/rpc/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1024n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://1rpc.io/base',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1000n,
  // },
  {
    url: 'https://base-pokt.nodies.app',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://base.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://base.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 40_000n,
  },
  {
    url: 'https://gateway.tenderly.co/public/base',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 80_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://rpc.notadegen.com/base',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 80_000n,
  // },
  {
    url: 'https://base-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://base.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  {
    url: 'https://base.api.onfinality.io/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://public.stackup.sh/api/v1/node/base-mainnet',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://base-mainnet.gateway.tatum.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://base.rpc.subquery.network/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const baseWebsocketRpcUrls: readonly string[] = [
  'wss://base.publicnode.com',
]
